import axios from 'axios';

import React, {useEffect, useRef} from 'react';

import {BackEndURL} from '../Config'
import t from 'typy';
import {stringify} from "qs";

let instance = axios.create({
    baseURL: BackEndURL,
    paramsSerializer: p => stringify(p, {arrayFormat: 'comma'})
});

instance.interceptors.request.use((cfg) => {
    let authToken = localStorage.getItem('auth');

    if (t(authToken).isString && !t(authToken).isEmptyString) {
        cfg.headers.Authorization = 'Bearer ' + authToken;
    }

    return cfg;
});

instance.isCancel = axios.isCancel

let x = 0;

export let useCancelToken = () => {
    let axiosSource = useRef(null);

    let cancelRequest = React.useCallback(() => {
        if (axiosSource.current)
            axiosSource.current.cancel();
        axiosSource.current = null
    }, [])

    let newToken = React.useCallback(() => {
        axiosSource.current = axios.CancelToken.source()
        axiosSource.current.id = x++
        return axiosSource.current
    }, [])

    let cancelRequestAndNewToken = React.useCallback(() => {
        cancelRequest()
        return newToken()
    }, [cancelRequest, newToken])

    useEffect(() => () => cancelRequest(), [cancelRequest]);

    return {
        cancelRequestAndNewToken,
        currentToken: () => axiosSource.current,
        cancelRequest,
        newToken,
        isCancel: axios.isCancel
    };
};

export default instance;